import firebase from "firebase";

export async function GetArchDeliveryList(page = 1) {
  const response = (await firebase.functions().httpsCallable('GetArchDeliveries')({
    page: page,
  })).data;
  try {
    if (!response.result) {
      console.log(response);
      return {
        data: [],
        count: 0,
      }
    } else {
      return {
        data: response.data,
        count: response.count,
      };
    }
  } catch (err) {
    console.log(err);
    return {
      data: [],
      count: 0,
    }
  }
}

export async function GetArchDeliveryWithPid(order_id) {
  const { result, data } =
    (await firebase.functions()
      .httpsCallable('GetArchDelivery')({
        order_id: order_id
      })).data;
  try {
    if (!result) {
      return [];
    } else {
      return data;
    }
  } catch (err) {
    console.log(err);
    return [];
  }
}